import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { SERVICES } from "@/data";

const SERVICES_BG = "https://images.unsplash.com/photo-1614595737476-42487331b8a1";

function ServiceCard({ s, index }) {
  const cardRef = useRef(null);
  const [pos, setPos] = useState({ x: "50%", y: "50%" });
  const Icon = s.icon;

  const onMove = (e) => {
    const r = cardRef.current.getBoundingClientRect();
    setPos({ x: `${e.clientX - r.left}px`, y: `${e.clientY - r.top}px` });
  };

  return (
    <motion.div
      ref={cardRef}
      onMouseMove={onMove}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-card p-8 md:p-10 ${s.span} min-h-[220px] flex flex-col justify-between hover:border-primary/50 transition-colors duration-300`}
      data-testid={`service-card-${s.id}`}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{ background: `radial-gradient(400px circle at ${pos.x} ${pos.y}, hsl(173 80% 40% / 0.12), transparent 40%)` }}
      />
      <div className="relative flex items-center justify-between">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
          <Icon size={22} />
        </div>
        <span className="font-heading text-sm text-muted-foreground/50">0{index + 1}</span>
      </div>
      <div className="relative mt-8">
        <h3 className="font-heading text-2xl md:text-3xl font-medium tracking-tight text-foreground">{s.title}</h3>
        <p className="mt-3 text-sm md:text-base text-muted-foreground leading-relaxed max-w-lg">{s.desc}</p>
      </div>
    </motion.div>
  );
}

export default function Services() {
  return (
    <section id="services" className="relative py-28 md:py-36 overflow-hidden" data-testid="services">
      <img src={SERVICES_BG} alt="" aria-hidden className="absolute inset-0 h-full w-full object-cover opacity-[0.04]" />
      <div className="relative max-w-screen-2xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-primary text-sm font-semibold tracking-[0.25em] uppercase">What we do</span>
          <h2 className="mt-4 font-heading font-light tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-foreground">
            A complete quality<br />partner for your build.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.id} s={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
